
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23 27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.467 25.5v-3.75c0-.414.343-.75.766-.75.424 0 .767.336.767.75v4.5c0 .414-.343.75-.767.75H.767A.759.759 0 010 26.25v-4.5c0-.414.343-.75.767-.75.423 0 .766.336.766.75v3.75h19.934zm-10.8-6.183V.786c0-.434.373-.786.833-.786.46 0 .833.352.833.786v18.531l5.243-4.945a.872.872 0 011.18 0 .757.757 0 010 1.113L12.09 21.77a.872.872 0 01-1.18 0l-6.666-6.285a.757.757 0 010-1.113.872.872 0 011.18 0l5.243 4.945z"}})])
          )
        }
      }
    